import { cleanInput } from '@exodus/basic-utils';
import { atom, swr } from '@exodus/headless-ui';
import fromAssetAtom from './from-asset.js';
import fromAmountAtom from './from-amount.js';
import limitsAtom from './limits.js';
import fiatModeAtom from './fiat-mode.js';
const fromFiatAmountAtom = atom((get, { selectors }) => {
    const fromAsset = get(fromAssetAtom);
    const fromAmount = get(fromAmountAtom);
    return get(selectors.fiatBalances.createAssetConversion(fromAsset.name))(fromAmount);
}, (get, set, value, { selectors }) => {
    const fromAsset = get(fromAssetAtom);
    const fiatCurrency = get(selectors.locale.currencyUnitType);
    const convert = get(selectors.fiatBalances.createConversion);
    const cleanedValue = cleanInput(value, fiatCurrency.defaultUnit.power);
    const fiatValue = fiatCurrency.defaultUnit(cleanedValue);
    const cryptoValue = convert(fromAsset.name)(fiatValue);
    const limits = get(swr(limitsAtom));
    const minLimit = (!limits.loading && limits.data?.ExactIn.min) || fromAsset.currency.ZERO;
    const minLimitFiatAmount = convert(fromAsset.name)(minLimit);
    const oneCent = fiatCurrency.defaultUnit(0.01);
    const isAlmostLimitMin = minLimitFiatAmount.sub(fiatValue).abs().lt(oneCent);
    const shuouldUseLimitMin = get(fiatModeAtom) && !minLimit.isZero && isAlmostLimitMin;
    set(fromAmountAtom, shuouldUseLimitMin ? minLimit : cryptoValue);
});
export default fromFiatAmountAtom;
